import localStorageKeys from 'constants/localStorageKeys';
import { getItem } from 'utils/localStorage';

export function getAuthorizationToken(): string {
  return getItem(localStorageKeys.userAuthorizations) || '';
}
